export const ROOT_PATH = '/tsat' as const;
export const NPS_PATH = '/nps' as const;
export const ERROR_PATH = '/error' as const;
export const SURVEY_PATH = '/:surveyUuid' as const;
